// What a tier still needs before it can be agreed.
//
// THE LIST IS COMPUTED BY THE BACKEND and read here, never recomputed. There
// are seven conditions — plan linked and approved, name, description, expected
// outcome, ZERO open questions, and dependencies that are active, of the same
// project and without open questions of their own — and one of them is about
// rows this panel cannot even see. Keeping a second copy of that logic in the
// browser means keeping two answers in agreement, and of two answers one goes
// stale.
//
// `ready_to_agree` IS NOT IN THE PUBLISHED CONTRACT. It is described in prose
// (mastermind_core/docs/09-desglose-persistencia.md) and absent from
// openapi.json, like `gate` and `errors` — see HT07.01-b. So this reads several
// shapes rather than destructuring one that was never promised: a list of
// strings, a list of objects, or nothing at all.

// Known codes get a sentence in Spanish. An UNKNOWN CODE IS SHOWN AS IT CAME,
// not dropped: a requirement nobody can read still blocks the agreement, and
// hiding it would leave a button disabled with no explanation.
const SENTENCE = {
    plan: 'Falta enlazar una versión de plan aprobada.',
    plan_version: 'Falta enlazar una versión de plan aprobada.',
    plan_approved: 'La versión de plan enlazada todavía no está aprobada.',
    name: 'Falta el nombre del tier.',
    description: 'Falta la descripción: qué entra y qué no.',
    expected_outcome: 'Falta el resultado esperado: qué tiene que existir al terminar.',
    open_questions: 'Hay dudas abiertas. Un tier se acuerda con cero.',
    dependencies: 'Alguna dependencia no está en condiciones: inactiva, de otro proyecto, o con dudas abiertas.',
};

export function readMissing(breakdown) {
    const raw = breakdown?.ready_to_agree?.missing ?? breakdown?.missing ?? null;
    if (!Array.isArray(raw)) return null;

    return raw.map((item, index) => {
        if (typeof item === 'string') {
            return { key: `${item}-${index}`, text: SENTENCE[item] ?? item };
        }
        // An object form: prefer the backend's own sentence, fall back to its
        // field name, and only then to our table.
        const field = item?.field ?? item?.code ?? item?.key;
        return {
            key: `${field ?? index}-${index}`,
            text: item?.message ?? SENTENCE[field] ?? field ?? 'Falta algo que el backend no supo nombrar.',
        };
    });
}

// Whether the tier can be agreed right now.
//
// Read from the backend when it says so; otherwise inferred ONLY from an empty
// `missing` list. If neither is there, the answer is `null` — «we do not know»
// — and the screen says that instead of guessing yes.
export function readReady(breakdown) {
    const ready = breakdown?.ready_to_agree;
    if (typeof ready === 'boolean') return ready;
    if (typeof ready?.ready === 'boolean') return ready.ready;
    if (Array.isArray(ready?.missing)) return ready.missing.length === 0;
    return null;
}
